module.exports = __webpack_public_path__ + "img/6.150eb1f7.jpg";